import React, { FC, ReactNode, useState } from 'react';
import Tooltip from '@mui/material/Tooltip';
import { t } from 'i18next';
import dayjs from 'dayjs';
import LoadingSpinner from '../../loadingSpinner/loadingSpinner';
import EmptyBigCard from './emptyBigCard';
import InfoIcon from '../../../assets/icons/info-icon.svg';
import { useDashboardFilterDateStore, useHistogramFilterDateStore } from '../../../store/dateRangeStore';

interface DashboardBigCardProps {
    title: string;
    isLoading?: boolean;
    isError?: boolean;
    children: ReactNode;
    showYearSelector?: boolean;
    info?: string;
    hasMoreThan12Months?: boolean;
    onYearClick?: (year: any) => void;
    headerRight?: React.ReactNode;
}

const DashboardBigCard: FC<DashboardBigCardProps> = (props) => {
  const currentYear = new Date().getFullYear();
  const lastYears = [currentYear - 2, currentYear - 1, currentYear];
  const { setHistogramFilterDateRange, setUserSelected } = useHistogramFilterDateStore();
  const [selectedYear, setSelectedYear] = useState<number | null>(null);

  const handleYearClick = (year: number) => {
    if (selectedYear === year) {
      setSelectedYear(null);
      setHistogramFilterDateRange([null, null]);
      setUserSelected(false);
    } else {
      setSelectedYear(year);
      const fromDate = dayjs(`${year}-01-01`).startOf('day');
      const toDate = dayjs(`${year}-12-31`).endOf('day');
      setHistogramFilterDateRange([fromDate, toDate]);
      setUserSelected(true);
    }
  };
  return (
    <div className="flex h-full min-h-0 flex-col overflow-hidden rounded-[8px]">
      <div className="mb-4 flex max-h-[47px] shrink-0 items-center justify-between gap-4 rounded-t-default border-b px-5 py-2
       text-primary"
      >
        <div className="flex items-center gap-4">
          <h2 className="text-[18px] font-[500] text-primary">{props.title}</h2>
          {props.info && (
            <Tooltip title={props.info}>
              <img src={InfoIcon} alt="" className="max-w-[20px]" />
            </Tooltip>
          )}
        </div>
        {props.showYearSelector && (
          <div className="flex items-center gap-2">
            {lastYears.map((year) => (
              <span
                key={year}
                className={`hover:cursor-pointer ${
                  selectedYear === year
                    ? 'font-bold text-primary underline'
                    : 'text-gray-400 hover:underline'
                }`}
                onClick={() => handleYearClick(year)}
              >
                {year}
              </span>
            ))}
          </div>
        )}
        {props.headerRight && (
        <div className="flex  gap-[68px]">
          {props.headerRight}
        </div>
        )}
      </div>

      <div className="flex min-h-0 flex-1 flex-col px-[20px] pb-4">
        {!props.isError && !props.children && (
        <div className="flex h-full -translate-y-[40px] flex-col items-center justify-center gap-4 text-center">
          {!props.isLoading ? (
            <EmptyBigCard />
          ) : (
            <LoadingSpinner center color="primary" />
          )}
        </div>
        )}

        {!props.isError && !props.isLoading && props.children && props.children}

        {props.isError && <p>{t('errorRetrievingData')}</p>}
      </div>
    </div>
  );
};

export default DashboardBigCard;
